<script setup lang="ts">
import { ref } from 'vue'

const props = withDefaults(defineProps<{
  steps: Array<{label: string}>
  currentStepIdx?: number,
  clickable?: boolean
  showLabels?: boolean
}>(), {
  currentStepIdx: 0,
  clickable: false,
  showLabels: true
})

const steps = ref(props.steps)

const emit = defineEmits<{
  (e: 'step-click', step: number): void
}>()

const handleStepClick = (step: number) => {
  emit('step-click', step)
}

</script>

<template>

  <ol
  class="stepwise-indicator"
  :class="{'stepwise-indicator-clickable': clickable}"
  :data-current-step-idx="currentStepIdx"
  >
    <li class="stepwise-indicator-item" v-for="(step,idx) in steps" :key="step.label + idx" :class="{
      'stepwise-indicator-item-active': idx === currentStepIdx,
      'stepwise-indicator-item-completed': idx < currentStepIdx,
      'stepwise-indicator-item-incomplete': idx > currentStepIdx
    }"
      @click="handleStepClick(idx)"
    >
      <span class="stepwise-indicator-item-label" :class="{'visually-hidden': !showLabels}">{{ step.label }}</span>
      <span class="stepwise-indicator-item-dot"></span>
  </li>
  </ol>
</template>

<style lang="scss" scoped>
.stepwise-indicator {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2);
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: bottom;
  font-size: var(--text-sm);
  font-family: var(--font-sans);
}

.stepwise-indicator-item {
  flex: 1;
}

.stepwise-indicator-clickable .stepwise-indicator-item {
  cursor: pointer;
}

.stepwise-indicator-item-label:not(.visually-hidden) {
  display: block;
  margin-bottom: var(--spacing-0-5);
  min-height: 1.2em; /* Reserve space for text even when hidden */
}

.stepwise-indicator-item-dot {
  border-radius: var(--spacing-0-5);
  height: var(--spacing-2);
  display: block;
}

.stepwise-indicator-item-active .stepwise-indicator-item-dot,
.stepwise-indicator-item-completed .stepwise-indicator-item-dot {
  background-color:var(--cu-blue-primary);
}

.stepwise-indicator-item-incomplete .stepwise-indicator-item-dot {
  background-color:var(--cu-gray-200);
}
</style>
